export default "__VITE_ASSET__Dya9YTLT__"